import React, { useEffect } from "react";

const NotificationMarqueeTemplate = (props) => {
    
    return (
        <>
            <div className='notification-text'>
                <marquee direction="left">
                    {props.notificationMarqueeText}
                </marquee>
            </div>
        </>
    )
}

export default NotificationMarqueeTemplate;